export default __webpack_public_path__ + "static/assets/00b8fd0fbdc14136504f17150ca49641.png";